import picsioConfig from '../../../../../config';
import sdk from '../../sdk';

/**
 * Fetch revisions for the asset
 * @param {string} assetId
 * @returns Promise<AxiosResponse>
 */
export default function getRevisions(assetId) {
  if (picsioConfig.isMainApp) return sdk.assets.getRevisions(assetId);

  return sdk.assets.getRevisionsPublic(
    picsioConfig.apiBaseUrl,
    window.websiteConfig.alias,
    assetId,
  );
}
